import { Component } from '@angular/core';

@Component({
  selector: 'app-invalid-role',
  imports: [],
  templateUrl: './invalid-role.component.html',
  styles: ``,
})
export class InvalidRoleComponent {

}
